import FontFaceObserver from 'fontfaceobserver';

export function markFontAsLoaded(fontFamily, options = {}) {
    return new FontFaceObserver(fontFamily, options)
        .load()
        .then(() => {
            document.documentElement.classList.add('fonts-loaded');
        })
        .catch(() => {});
}
